import { Icon, IconProps } from '@chakra-ui/react'

export default function DatabaseIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33398 11.9997C3.33398 12.9203 5.42332 13.6663 8.00065 13.6663C10.578 13.6663 12.6673 12.9203 12.6673 11.9997V3.99967C12.6673 3.07901 10.578 2.33301 8.00065 2.33301C5.42332 2.33301 3.33398 3.07901 3.33398 3.99967V11.9997Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6673 3.99902C12.6673 4.91969 10.578 5.66569 8.00065 5.66569C5.42332 5.66569 3.33398 4.91969 3.33398 3.99902"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6673 9.33301C12.6673 10.2537 10.578 10.9997 8.00065 10.9997C5.42332 10.9997 3.33398 10.2537 3.33398 9.33301"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6673 6.66602C12.6673 7.58668 10.578 8.33268 8.00065 8.33268C5.42332 8.33268 3.33398 7.58668 3.33398 6.66602"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
